// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"197":"ui5-webcomponents-sap-icons-v5","804":"ui5-webcomponents-sap-icons-v4"}[chunkId] || chunkId) + "." + {"116":"01d3d858","133":"0767c3e2","197":"51d196b8","324":"8232c795","804":"ae48730d","906":"1385929c"}[chunkId] + ".chunk.js";
};